import { useState } from 'react';
import Section from '../Section';
import { createUser, getErrorMessage, loginUser } from '../../helpers/lib/axios';
import { useAppToast } from '../../helpers/lib/useAppToast';

const SignUp = () => {
    const toast = useAppToast()
    const [reg, setReg] = useState(true)
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('')
    const [gender, setGender] = useState('')
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)

    const handleSignUp = async (e) => {
        e.preventDefault()
        setError('')
        if (email === '' || password === '' || firstName === '' || lastName === '' || gender === '') {
            toast({
                status: 'error',
                description: 'Please fill all required fields',
            })
            return
        }
        setLoading(true)
        const userPayload = {
            email,
            password,
            firstName,
            lastName,
            gender,
        };

        // Only add phoneNumber if it exists
        if (phoneNumber) {
            userPayload.phoneNumber = phoneNumber;
        }

        try {
            const result = await createUser(userPayload);
            if (result?.statusCode === 201) {
                toast({
                    status: 'success',
                    description: result?.message || 'Account created. Please sign in.',
                })
                setReg(false)
            } else {
                toast({
                    status: 'info',
                    description: result?.message || 'Sign up did not complete. Please try again.',
                })
            }
        } catch (error) {
            const message = getErrorMessage(error, 'Sign up failed. Please try again.')
            toast({ status: 'error', description: message })
            setError(message)
        } finally {
            setLoading(false)
        }
    }

    const handleSignIn = async (e) => {
        e.preventDefault()
        setError('')
        if (email === '' || password === '') {
            toast({
                status: 'error',
                description: 'Please fill all required fields',
            })
            return
        }
        setLoading(true)
        const userPayload = {
            email,
            password,
        };

        try {
            const result = await loginUser(userPayload);
            if (result?.statusCode === 200 && result?.data?.token) {
                toast({
                    status: 'success',
                    description: result?.message || 'Signed in',
                })
                // Full page load so the header picks up the signed-in user.
                window.location.assign(result?.data?.user?.isAdmin ? '/admin' : '/')
                return
            }
            toast({
                status: 'info',
                description: result?.message || 'Sign in did not complete. Please try again.',
            })
        } catch (error) {
            const message = getErrorMessage(error, 'Sign in failed. Please try again.')
            toast({ status: 'error', description: message })
            setError(message);
        } finally {
            setLoading(false)
        }
    }

    return (<>
        <Section
            topSm={112}
            topMd={200}
            topLg={150}
            topXl={110}
            bottomMd={200}
            bottomLg={150}
            bottomXl={110}
        >
            <div className="container">
                <div className="row">
                    {reg ? <div className="col-lg-7">
                        <h2 className="cs_fs_40 cs_medium mb-0">Sign Up</h2>
                        <div className="cs_height_42 cs_height_xl_25" />
                        <form action="#" className="row">
                            <div className="col-lg-6">
                                <label className="cs_input_label cs_heading_color">First Name</label>
                                <input type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} className="cs_form_field" placeholder="Enter first name..." />
                                <div className="cs_height_42 cs_height_xl_25" />
                            </div>
                            <div className="col-lg-6">
                                <label className="cs_input_label cs_heading_color">Last Name</label>
                                <input
                                    type="text"
                                    className="cs_form_field"
                                    placeholder="Enter last name..."
                                    value={lastName} onChange={(e) => setLastName(e.target.value)}
                                />
                                <div className="cs_height_42 cs_height_xl_25" />
                            </div>
                            <div className="col-lg-6">
                                <label className="cs_input_label cs_heading_color">
                                    Email Address
                                </label>
                                <input
                                    type="email"
                                    className="cs_form_field"
                                    placeholder="Enter email address..."
                                    value={email} onChange={(e) => setEmail(e.target.value)}
                                />
                                <div className="cs_height_42 cs_height_xl_25" />
                            </div>
                            <div className="col-lg-6">
                                <label className="cs_input_label cs_heading_color">
                                    Gender
                                </label>
                                <select name="" id="" className="cs_form_field" value={gender} onChange={(e) => setGender(e.target.value)}>
                                    <option value="" disabled>Select a gender</option>
                                    <option value="MALE">Male</option>
                                    <option value="FEMALE">Female</option>
                                    <option value="OTHER">Other</option>
                                </select>
                                <div className="cs_height_42 cs_height_xl_25" />
                            </div>
                            <div className="col-lg-6">
                                <label className="cs_input_label cs_heading_color">Password</label>
                                <input type="password" className="cs_form_field" placeholder="Enter password" value={password} onChange={(e) => setPassword(e.target.value)} />
                                <div className="cs_height_42 cs_height_xl_25" />
                            </div>
                            <div className="col-lg-6">
                                <label className="cs_input_label cs_heading_color">Phone Number (optional)</label>
                                <input type="tel" className="cs_form_field" placeholder="Enter phone number" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
                                <div className="cs_height_42 cs_height_xl_25" />
                            </div>

                            <p className='text-[#981D0E] font-semibold'>{error}</p>

                            <div className="col-lg-12">
                                <button className="cs_btn cs_style_1" onClick={(e) => handleSignUp(e)}>
                                    <span>{loading ? "Loading..." : "Sign Up"}</span>
                                    <i>
                                        <img src="/images/icons/arrow_white.svg" alt="Icon" />
                                        <img src="/images/icons/arrow_white.svg" alt="Icon" />
                                    </i>
                                </button>
                            </div>

                            <div className='mt-3'>
                                <p>Already have an account? <span className='text-[#981D0E] font-semibold cursor-pointer' onClick={() => setReg(!reg)} >Sign In</span></p>
                            </div>
                        </form>
                    </div> : <div className="col-lg-7">
                        <h2 className="cs_fs_40 cs_medium mb-0">Sign In</h2>
                        <div className="cs_height_42 cs_height_xl_25" />
                        <form action="#" className="row">
                            <div className="col-lg-12">
                                <label className="cs_input_label cs_heading_color">
                                    Email Address
                                </label>
                                <input
                                    type="email"
                                    className="cs_form_field"
                                    placeholder="Enter email address..."
                                    value={email} onChange={(e) => setEmail(e.target.value)}
                                />
                                <div className="cs_height_42 cs_height_xl_25" />
                            </div>
                            <div className="col-lg-12">
                                <label className="cs_input_label cs_heading_color">Password</label>
                                <input type="password" className="cs_form_field" placeholder="Enter password" value={password} onChange={(e) => setPassword(e.target.value)} />
                                <div className="cs_height_42 cs_height_xl_25" />
                            </div>

                            <p className='text-[#981D0E] font-semibold'>{error}</p>


                            <div className="col-lg-12">
                                <button className="cs_btn cs_style_1" onClick={(e) => handleSignIn(e)}>
                                        <span>{loading ? "Loading..." : "Sign In"}</span>
                                    <i>
                                        <img src="/images/icons/arrow_white.svg" alt="Icon" />
                                        <img src="/images/icons/arrow_white.svg" alt="Icon" />
                                    </i>
                                </button>
                            </div>                            <div className='mt-3'>
                                <p>Don&apos;t have an account? <span className='text-[#981D0E] font-semibold cursor-pointer' onClick={() => setReg(!reg)} >Sign Up</span></p>
                            </div>
                        </form>
                    </div>}
                    <div className="hidden lg:flex col-lg-4 offset-lg-1">
                        <div className="cs_height_lg_100" />
                        {/* <h2 className="cs_fs_40 cs_medium mb-0">Contact Info</h2> */}
                        <div className="cs_height_60 cs_height_xl_40" />
                        <img
                            src="/illustrations/Noohra-Services Hero7.webp"
                            alt="Appointment"
                            className="cs_radius_25 w-100"
                        />
                        <div className="cs_height_100 cs_height_xl_60" />
                    </div>
                </div>
            </div>
        </Section>
    </>);
}

export default SignUp;